/* Catalog Brand Guide */
const toast = document.getElementById("toast");
      let timer;
      async function copyHex(hex) {
        const value = hex.toUpperCase();
        try {
          await navigator.clipboard.writeText(value);
        } catch {
          const ta = document.createElement("textarea");
          ta.value = value;
          document.body.appendChild(ta);
          ta.select();
          document.execCommand("copy");
          ta.remove();
        }
        toast.textContent = `Copied ${value}`;
        toast.classList.add("on");
        clearTimeout(timer);
        timer = setTimeout(() => toast.classList.remove("on"), 1200);
      }
      document.addEventListener("click", (e) => {
        const el = e.target.closest("[data-hex]");
        if (el) copyHex(el.dataset.hex);
      });
